<template>
  <div
    class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
  >
    <Flexpropcard
      :schema="flexprop_schema_current"
      :values="{}"
      :disabled="false"
      :cardname="card"
      v-for="card in flexpropcards"
      :key="card"
      :test-mode="true"
    />
  </div>
</template>

<script>
import Flexpropcard from "../Accommodatie/Voorziening/Flexpropcard/Flexpropcard.vue";

export default {
  name: "CurrentFlexPropsSchema",
  props: ["flexprop_schema_current"],
  components: {
    Flexpropcard
  },

  computed: {
    flexpropcards: function() {
      const current_schema = this.flexprop_schema_current;
      if (!current_schema) {
        return [];
      }

      return Object.values(current_schema.properties).reduce(
        (cardnames, item) => {
          if (!cardnames.includes(item.card)) {
            cardnames.push(item.card);
          }
          return cardnames;
        },
        []
      );
    }
  }
};
</script>
